// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// Styles
import './OMTabs.scss';

class OMTab extends Component {
  state = {
    alreadyWasRendered: this.props.isActive
  };

  componentWillReceiveProps({ isActive }) {
    if (isActive && isActive !== this.props.isActive) {
      this.setState({ alreadyWasRendered: isActive });
    }
  }

  renderContent = () => ((this.state.alreadyWasRendered) ? this.props.children : null);

  render() {
    return (
      <div id={`om-tab-${this.props.id}`} className={cx('om-content', this.props.className)}>
        {this.renderContent()}
      </div>
    );
  }
}

OMTab.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.node,
    PropTypes.array
  ])
};

export default OMTab;
